export default __webpack_public_path__ + "static/media/iniComputacion.0e9af8fe.png";